import CardListMap from '../../Company/Payroll/Subcomponents/CardListMap';
import { IconClockTable, VehicleChip } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status } from '../../../../enums/statusEnum';
import VehicleSectionApp from '../Functionality/VehicleSectionApp';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import VehicleModal from '../modal/VehicleModal';
import {
    buildVehicleFullName,
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat
} from '../../../../Apis/functions';
import NotInformation from '../../../../components/NotInformation';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const VehicleSection = ({ userTypeId, contractorId, profile, model, supplierId, historyModel,  noInformationTitle}) => {
    const {
        t,
        showModal,
        setShowModal,
        selected,
        setSelected,
        searchId,
        results,
        searchElement,
        setSearchElement,
        setSearch,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        setData,
        pagination,
        getActionsButtons,
    } = VehicleSectionApp({
        contractorId,
        supplierId,
        model
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setSearchResults={setData}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={model}
                page={page}
                rowsPerPage={rowsPerPage}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                label='search_by_name'
                contractorId={contractorId}
                supplierId={supplierId}
                setSearch={setSearch}
            />
            {results?.content?.length > 0 ? (
                <>
                    {results.content.map((item, index) => (
                        <CardListMap
                            key={item.id}
                            icon={<VehicleChip className='w-32px h-30px pt-8px' />}
                            backgroundColor='background-shades-100'
                            classContainerIcon='h-56px w-56px mt-10px background-secondary-100 '
                            colIcon='col-auto col-md-1 p-3 p-md-0'
                            colBody='col col-md-11'
                            body={
                                <>
                                    <div className='row align-items-center ml-2'>
                                        <div className='col-6 d-flex align-items-center'>
                                            <div className='flex-grow-1 minw-0'>
                                                <CustomTooltip
                                                    text={buildVehicleFullName(item)}
                                                    classes={
                                                        'font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows ml-2 text-capitalize'
                                                    }
                                                    showIfTruncated={true}
                                                    placement={'top'}
                                                />
                                            </div>
                                        </div>

                                        <div className='col-6 d-flex justify-content-end'>
                                            {getActionsButtons(item, index)}
                                        </div>
                                    </div>

                                    <div className='row align-items-center justify-content-start ml-3'>
                                        <div className='col-6 col-md-8 d-flex align-items-center gap-2 mb-2 mb-md-0'>
                                            <IconClockTable className='icon-color-shades-500' />
                                            <p className='fs-14px font-color-shades-500 ibl-font-w-400 mb-0'>
                                                {t('last_activity')}:{' '}
                                                { item?.updatedAt ?
                                                    getDateFormat(item?.updatedAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                                    :
                                                    EMPTY_VALUES.DEFAULT
                                                }
                                            </p>
                                        </div>
                                        <div className='col-6 col-md-4 d-flex justify-content-end justify-content-md-end'>
                                            <CustomChip
                                                background={statusColor[item.statusId]}
                                                fontColor={statusFontColor[item.statusId]}
                                                borderColor={statusBorderColor[item.statusId]}
                                                legend={t(status[item.statusId]) || EMPTY_VALUES.DEFAULT}
                                                variant={"large"}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        />
                    ))}
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    text={t('no_vehicle_documentation')}
                    card={true}
                />
            )}
            {showModal && (
                <VehicleModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    item={selected}
                    setItem={setSelected}
                    icon={<VehicleChip className='mr-8px mb-1 icon-color-general-950' />}
                    userTypeId={userTypeId}
                    profile={profile}
                    historyModel={historyModel}
                    noInformationTitle={ noInformationTitle}
                />
            )}
        </>
    );
};

export default VehicleSection;
